import App from './App.svelte';

// Together with the use of rollup-plugin-css-only, this causes
// sanitize.css to be added to /build/extra.css.
import 'sanitize.css'

const app = new App({ target: document.body });

export default app;
